import * as React from "react";
import { forwardRef } from "react";
const SvgSeat = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", fill: "currentColor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M280-120q-38 0-71.5-17T152-184q-23-30-30-67.5t4-73.5l24-82-30-427 80-6q66-5 115.5 39T370-691l9 119q5 66-38.5 116T231-401l-28 98q-5 18-1.5 37t14.5 34q5 6 11 11t14 10q5-63 50.5-106T400-360h280q66 0 113 47t47 113v80H280Zm40-80h440q0-33-23.5-56.5T680-280H400q-33 0-56.5 23.5T320-200Zm-96-280q33-2 55-27.5t20-58.5l-9-119q-2-33-27-55t-58-20l19 280Zm316 280ZM215-622Z" }));
const ForwardRef = forwardRef(SvgSeat);
export default ForwardRef;
